// Automatic theme management based on system preferences
export const initializeTheme = () => {
  // For now, always follow system preferences (clear any old saved preferences)
  localStorage.removeItem('theme');
  
  // Follow system preference
  const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  document.documentElement.classList.toggle('dark', systemPrefersDark);
  
  // Set to system to indicate we're following system preferences
  localStorage.setItem('theme', 'system');
};

// Listen for system theme changes
export const setupThemeListener = () => {
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
  
  const handleThemeChange = (e: MediaQueryListEvent) => {
    // Only auto-update if following system preferences
    const savedTheme = localStorage.getItem('theme');
    if (!savedTheme || savedTheme === 'system') {
      document.documentElement.classList.toggle('dark', e.matches);
      localStorage.setItem('theme', 'system');
    }
  };
  
  mediaQuery.addEventListener('change', handleThemeChange);
  
  // Return cleanup function
  return () => mediaQuery.removeEventListener('change', handleThemeChange);
};